import { render } from "./BillingDetails.vue?vue&type=template&id=35c1497a"
import script from "./BillingDetails.vue?vue&type=script&lang=ts"
export * from "./BillingDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script